// Arbox staff roles — parsing, the "everyone gets it" filter, and Hebrew labels.
//
// user_role is a raw comma-separated string of role NAMES (e.g.
// "COACH, BASICMANAGER, SALESMAN"). We:
//   1. drop BASICMANAGER — every staff member gets it, so it carries no signal.
//   2. translate the known Arbox enum values to Hebrew for display + filtering.
// Unknown roles fall through untranslated (visible, not hidden) so a new Arbox
// role is obvious rather than silently dropped.

// Roles that are noise on every staff member — removed from display + filters.
const HIDDEN_ROLES = new Set(['BASICMANAGER']);

// Hebrew labels for the Arbox role enum (keys upper-cased; see the role chips in
// the Arbox permissions UI: Coach/BoxAdmin/SalesMan/… ).
const ROLE_LABELS: Record<string, string> = {
  OWNER: 'בעלים',
  BOXADMIN: 'מנהל העסק',
  MANAGER: 'מנהל',
  COACH: 'מאמן/מדריך/מטפל',
  SALESMAN: 'איש מכירות',
  SALESMANAGER: 'מנהל מכירות',
  SECRETARY: 'מזכירות',
  RECEPTIONLIST: 'קבלה',
  RECEPTION: 'קבלה',
  SERVICE: 'שירות לקוחות',
  REGULAR: 'רגיל',
  SIGNUPACCESS: 'בקרת כניסה',
};

/** Parse user_role → normalized, de-noised role keys (BASICMANAGER removed). */
export function parseRoles(userRole: string | null): string[] {
  if (!userRole) return [];
  return userRole
    .split(',')
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean)
    .filter((r) => !HIDDEN_ROLES.has(r));
}

/** Hebrew label for a single role key (falls back to the raw key). */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}

/** Hebrew labels for a user_role string, de-noised. */
export function roleLabels(userRole: string | null): string[] {
  return parseRoles(userRole).map(roleLabel);
}
